export default __webpack_public_path__ + "static/N0051-e724c03f74a02c32df3e4f73aabfbbe9.png";